import React from 'react';
import {useTheme} from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';

import {Button} from '../../../../components/Interface/Forms/Buttons/Button';

import {Wrapper, Title, Subtitle, ButtonContainer} from './styles';
import CouponTicket from '../CouponTicket';

interface Props {
  onPress: () => void;
}

export function BuyCouponCard({onPress}: Props) {
  const theme = useTheme();

  return (
    <Wrapper>
      <CouponTicket color={theme.colors.primary}/>

      <Title>Você ainda não tem cupons</Title>
      <Subtitle>Economize agora mesmo!</Subtitle>

<ButtonContainer>
      <Button
        title="Comprar agora"
        color={theme.colors.primary}
        onPress={onPress}
        mt={RFValue(12)}
      />
      </ButtonContainer>
    </Wrapper>
  );
}
